import * as types from './constants';

// Send Unmasking Invitation
export const sendUnmaskingInvitationRequest = data => (
  { type: types.SEND_UNMASKING_INVITATION_REQUEST, payload: data }
);

export const sendUnmaskingInvitationDone = data => (
  { type: types.SEND_UNMASKING_INVITATION_DONE, payload: data }
);

export const sendUnmaskingInvitationFailed = errors => (
  { type: types.SEND_UNMASKING_INVITATION_FAILED, payload: errors }
);

export const sendUnmaskingInvitationReset = () => (
  { type: types.SEND_UNMASKING_INVITATION_RESET }
);